const spark = {
  orange10: '#8c3100',
  orange9: '#b23c00',
  orange8: '#d14200',
  orange7: '#e85313',
  orange6: '#f76d36',
  orange5: '#ff895d',
  orange4: '#ffa480',
  orange3: '#ffbb93',
  orange2: '#ffd2bd',
  orange1: '#ffe4d6',

  red10: '#91001d',
  red9: '#bd0026',
  red8: '#d91838',
  red7: '#ed374f',
  red6: '#fa5768',
  red5: '#ff7881',
  red4: '#ff969a',
  red3: '#ffb5b5',
  red2: '#ffcccc',
  red1: '#ffdede',

  yellow10: '#7a5800',
  yellow9: '#996e00',
  yellow8: '#bd8700',
  yellow7: '#d99b00',
  yellow6: '#edaa00',
  yellow5: '#fabc20',
  yellow4: '#ffcd4d',
  yellow3: '#ffda79',
  yellow2: '#ffe6a4',
  yellow1: '#fff2cf',

  green10: '#00544c',
  green9: '#00665a',
  green8: '#008573',
  green7: '#00a68d',
  green6: '#00c2a1',
  green5: '#00d9b1',
  green4: '#23ebc3',
  green3: '#57f7d5',
  green2: '#8cffe4',
  green1: '#bfffef',

  cyan10: '#004e61',
  cyan9: '#006075',
  cyan8: '#007b94',
  cyan7: '#0097b2',
  cyan6: '#00b1cc',
  cyan5: '#00c6e0',
  cyan4: '#18daf0',
  cyan3: '#4bebfa',
  cyan2: '#80f6ff',
  cyan1: '#b2fbff',

  purple10: '#3a00a6',
  purple9: '#4900d1',
  purple8: '#5823f3',
  purple7: '#6a4dff',
  purple6: '#7a6bff',
  purple5: '#928cff',
  purple4: '#aaa8ff',
  purple3: '#bfbfff',
  purple2: '#d3d3ff',
  purple1: '#e5e5ff',

  blue10: '#003694',
  blue9: '#0046b8',
  blue8: '#0057d9',
  blue7: '#2176ed',
  blue6: '#4191fa',
  blue5: '#61a8ff',
  blue4: '#80bbff',
  blue3: '#9ecdff',
  blue2: '#bddeff',
  blue1: '#d6ebff',

  black: '#101014',
  gray100: '#23232b',
  gray90: '#373642',
  gray80: '#4c4b59',
  gray70: '#626070',
  gray60: '#787787',
  gray50: '#908e9e',
  gray40: '#a8a7b5',
  gray30: '#c1c0cc',
  gray20: '#d9d8e3',
  gray10: '#f5f5fa'
};

export const colors = {
  background: spark.gray10,
  foreground: spark.gray10,
  onSurface: '#ffffff',
  muted: spark.gray60,
  text: '#1c1c1f',
  primary: spark.orange4,
  secondary: spark.cyan4,
  success: spark.green6,
  error: spark.red6,
  warning: spark.yellow6,
  link: spark.orange4,
  linkHover: spark.orange4,
  transparent: 'transparent',
  border: '#E5E7EB',
  neutral: 'rgba(255, 255, 255, 0.15)',
  tooltip: spark.black,
  white85: 'rgba(255, 255, 255, 0.85)',
  chartLine: spark.orange4,
  chartIndicatorLine: spark.gray30,
  chartUp: '#45C8E5',
  chartDown: '#A979D8',
  tableRowHover: spark.gray90,
  tableStickyBg: spark.gray10,
  skeleton: {
    baseColor: spark.gray10,
    highlightColor: spark.gray100
  },
  sparkLiquidityLayerColor: '#d73fdc',
  sparkSavingsColor: '#00C835',
  sparkLendColor: '#ffab55',
  sparkSpkColor: '#fa43bd',
  spark: spark,
  // deposit: 'rgba(0, 245, 170, 0.2)',
  // withdrawal: 'rgba(255, 100, 100, 0.2)',
  // transfer: 'rgba(255, 255, 100, 0.2)',
  deposit: spark.green6,
  withdrawal: spark.red6,
  transfer: spark.orange4,
  aaveColor: '#9391f7',
  progressBarOthers: spark.yellow3
};
